import React from 'react';

const CheckMarkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
    <g clipPath="url(#clip0_592_153556)">
      <path
        d="M51.0588 0H4.94118C2.21224 0 0 2.21223 0 4.94116V51.0586C0 53.7876 2.21224 55.9998 4.94118 55.9998H51.0588C53.7878 55.9998 56 53.7876 56 51.0586V4.94116C56 2.21223 53.7878 0 51.0588 0Z"
        fill="url(#paint0_linear_592_153556)"
      />
      <g opacity="0.9">
        <path
          d="M51.0588 0H4.94118C2.21224 0 0 2.21223 0 4.94116V51.0586C0 53.7876 2.21224 55.9998 4.94118 55.9998H51.0588C53.7878 55.9998 56 53.7876 56 51.0586V4.94116C56 2.21223 53.7878 0 51.0588 0Z"
          fill="url(#paint1_linear_592_153556)"
        />
        <path
          d="M0 4.94137L0 51.0588C0 53.7878 2.21224 56 4.94118 56H51.0588C53.7878 56 56 53.7878 56 51.0588V4.94137C56 2.21244 53.7878 0.000213623 51.0588 0.000213623H4.94118C2.21224 0.000213623 0 2.21244 0 4.94137Z"
          fill="url(#paint2_linear_592_153556)"
        />
        <path
          d="M4.94118 56L51.0588 56C53.7878 56 56 53.7878 56 51.0588L56 4.94137C56 2.21244 53.7878 0.000213623 51.0588 0.000213623L4.94118 0.000213623C2.21224 0.000213623 0 2.21244 0 4.94137L0 51.0588C0 53.7878 2.21224 56 4.94118 56Z"
          fill="url(#paint3_linear_592_153556)"
        />
        <path
          d="M56 51.0586V4.94116C56 2.21223 53.7878 0 51.0588 0L4.94118 0C2.21224 0 0 2.21223 0 4.94116V51.0586C0 53.7876 2.21224 55.9998 4.94118 55.9998H51.0588C53.7878 55.9998 56 53.7876 56 51.0586Z"
          fill="url(#paint4_linear_592_153556)"
        />
      </g>
      <path
        d="M24.7059 44.4705C23.8323 44.4703 22.9946 44.1232 22.3769 43.5053L7.23224 28.2833C6.92346 27.9744 6.75 27.5556 6.75 27.1188C6.75 26.6821 6.92346 26.2632 7.23224 25.9543L9.56118 23.6254C9.87005 23.3166 10.2889 23.1432 10.7256 23.1432C11.1624 23.1432 11.5813 23.3166 11.8901 23.6254L24.5511 36.3621L43.9765 14.2142C44.1193 14.0515 44.2927 13.9186 44.4869 13.8231C44.6811 13.7275 44.8922 13.6711 45.1082 13.6572C45.3242 13.6433 45.5408 13.6721 45.7457 13.7419C45.9505 13.8118 46.1396 13.9213 46.3021 14.0643L48.7727 16.24C49.1007 16.5284 49.3007 16.9352 49.3288 17.371C49.3569 17.8068 49.2108 18.2359 48.9226 18.564L27.1765 43.3505C26.8797 43.6889 26.5167 43.9628 26.1099 44.1555C25.7031 44.3481 25.2611 44.4553 24.8113 44.4705H24.7059Z"
        fill="url(#paint5_linear_592_153556)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_592_153556"
        x1="27.9967"
        y1="0"
        x2="27.9967"
        y2="55.9998"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A2FF94" />
        <stop offset="1" stopColor="#27C411" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_592_153556"
        x1="0.00494118"
        y1="27.9999"
        x2="55.9885"
        y2="27.9999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#81EB73" stopOpacity="0" />
        <stop offset="0.41" stopColor="#80EA72" stopOpacity="0.012" />
        <stop offset="0.558" stopColor="#7BE76D" stopOpacity="0.055" />
        <stop offset="0.663" stopColor="#73E165" stopOpacity="0.13" />
        <stop offset="0.749" stopColor="#68D959" stopOpacity="0.237" />
        <stop offset="0.821" stopColor="#59CE49" stopOpacity="0.376" />
        <stop offset="0.886" stopColor="#46C136" stopOpacity="0.548" />
        <stop offset="0.943" stopColor="#31B120" stopOpacity="0.747" />
        <stop offset="0.995" stopColor="#19A007" stopOpacity="0.977" />
        <stop offset="1" stopColor="#169E04" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_592_153556"
        x1="28"
        y1="55.3033"
        x2="28"
        y2="-0.680019"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#81EB73" stopOpacity="0" />
        <stop offset="0.41" stopColor="#80EA72" stopOpacity="0.012" />
        <stop offset="0.558" stopColor="#7BE76D" stopOpacity="0.055" />
        <stop offset="0.663" stopColor="#73E165" stopOpacity="0.13" />
        <stop offset="0.749" stopColor="#68D959" stopOpacity="0.237" />
        <stop offset="0.821" stopColor="#59CE49" stopOpacity="0.376" />
        <stop offset="0.886" stopColor="#46C136" stopOpacity="0.548" />
        <stop offset="0.943" stopColor="#31B120" stopOpacity="0.747" />
        <stop offset="0.995" stopColor="#19A007" stopOpacity="0.977" />
        <stop offset="1" stopColor="#169E04" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_592_153556"
        x1="55.4021"
        y1="28.0001"
        x2="-0.581412"
        y2="28.0001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#81EB73" stopOpacity="0" />
        <stop offset="0.41" stopColor="#80EA72" stopOpacity="0.012" />
        <stop offset="0.558" stopColor="#7BE76D" stopOpacity="0.055" />
        <stop offset="0.663" stopColor="#73E165" stopOpacity="0.13" />
        <stop offset="0.749" stopColor="#68D959" stopOpacity="0.237" />
        <stop offset="0.821" stopColor="#59CE49" stopOpacity="0.376" />
        <stop offset="0.886" stopColor="#46C136" stopOpacity="0.548" />
        <stop offset="0.943" stopColor="#31B120" stopOpacity="0.747" />
        <stop offset="0.995" stopColor="#19A007" stopOpacity="0.977" />
        <stop offset="1" stopColor="#169E04" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_592_153556"
        x1="28"
        y1="-0.093882"
        x2="28"
        y2="55.8894"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#81EB73" stopOpacity="0" />
        <stop offset="0.41" stopColor="#80EA72" stopOpacity="0.012" />
        <stop offset="0.558" stopColor="#7BE76D" stopOpacity="0.055" />
        <stop offset="0.663" stopColor="#73E165" stopOpacity="0.13" />
        <stop offset="0.749" stopColor="#68D959" stopOpacity="0.237" />
        <stop offset="0.821" stopColor="#59CE49" stopOpacity="0.376" />
        <stop offset="0.886" stopColor="#46C136" stopOpacity="0.548" />
        <stop offset="0.943" stopColor="#31B120" stopOpacity="0.747" />
        <stop offset="0.995" stopColor="#19A007" stopOpacity="0.977" />
        <stop offset="1" stopColor="#169E04" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_592_153556"
        x1="28.0445"
        y1="13.6558"
        x2="28.0445"
        y2="44.4705"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.375" stopColor="white" />
        <stop offset="0.606" stopColor="#FCFCFD" />
        <stop offset="0.784" stopColor="#F2F2F6" />
        <stop offset="0.943" stopColor="#E2E2EB" />
        <stop offset="1" stopColor="#DADAE6" />
      </linearGradient>
      <clipPath id="clip0_592_153556">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CheckMarkIcon;
